import { CheckCheck, PartyPopper, SendHorizonalIcon, Trash2 } from 'lucide-react';
import moment from 'moment';
import React from 'react';
import icEmpire from "../assets/logos/logo-empire-str.png";
import { useSocket } from '../Context/SocketContext';
import { infoUser } from '../utils/auth';

const TalkTypeWaitAskPaiementAccept = ({ m, deleteMessage }) => {
    const { projectJson } = useSocket()

    return (
        <div className='df fdc aic jcc w100 bcw py2 px1' style={{ borderRadius: "10px" }}>
            <div className='df aic jcsb w100'>
                <div className='df aic gap1'>
                    <div className='c-avatar'>
                        {m.role == "user" && (
                            <img className='avatar' src={projectJson?.href + "/images/users/" + m.path}></img>
                        )}

                    </div>
                    <div className='df fdc'>
                        <div className='df gap1 aic'>
                            <SendHorizonalIcon color={'#0074dc'} size={20} />
                            <p style={{ fontSize: "0.8em" }} className='fr cb tal'>{moment(m.date).fromNow()}</p>
                        </div>
                        {m.status == "Lu" && (
                            <div className='df gap1 aic'>
                                <CheckCheck color={'#0074dc'} size={20} />
                                <p style={{ fontSize: "0.8em" }} className='fr cb tal'>{moment(m.date_read).fromNow()}</p>
                            </div>
                        )}
                    </div>
                </div>

                <div>
                    <button onClick={deleteMessage}><Trash2 color='#f71717' size={20} /></button>
                </div>
            </div>

            <p className='fb cb fs1 tac py1'>Demande de paiement</p>
            <p className='fr cgrey tac '>Vous avez accepter d'envoyer la demande de paiement</p>
            <p className='tac fr cgrey2 '>En attente de paiement</p>
        </div>
    );
};

export default TalkTypeWaitAskPaiementAccept;